import { html } from '@resn/gozer-core';
import { DomComponentMixin } from '@resn/gozer-core-mixins';
import { Component, componentMixin } from '@resn/gozer-core/component';
import gsap from 'gsap';
// import { loadImage } from '@resn/gozer-loading/loaders';
import picture from 'utils/picture';
import './index.scss';

@componentMixin(DomComponentMixin)
class MaterialImage extends Component {
    options = {
        template: ({ options }) =>
            html`${picture({
                classNamePicture: 'imageMaterialPicture',
                className: `imageMaterial ${options.classNameParent}__imageMaterial`,
                src: options.src,
            })}`,
        src: '',
        classNameParent: '',
    };

    props = {
        v: false,
        active: false,
        activeDelay: null,
    };

    async onSetup() {
        this.el.style.position = 'absolute';
    }

    onActive() {
        this.el.style['z-index'] = 1;
        this.props.v = true;
        const delay = this.props.activeDelay || 0;
        this.killTween();
        gsap.fromTo(this.el, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'sine.out', delay });
    }
    offActive() {
        this.el.style['z-index'] = 0;
        const delay = this.props.activeDelay || 0;
        this.killTween();
        gsap.to(this.el, {
            opacity: 0,
            duration: 0.6,
            ease: 'sine.in',
            delay,
            onComplete: () => (this.props.v = false),
        });
    }

    killTween() {
        gsap.killTweensOf(this.el);
    }

    setV(bool) {
        this.el.style.visibility = bool ? 'visible' : 'hidden';
    }
}
export default MaterialImage;
